module.exports = __webpack_public_path__ + "img/compact.3c404536.png";